module.exports = __webpack_public_path__ + "img/default_pattern_02.4ad7a518.png";